import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

import * as HS from './styled';

interface IProps {
    headerClickHandler: () => void,
}

const Header = ({ headerClickHandler }: IProps): JSX.Element => {
    return (
        <HS.HeadWrapper>
            <GridContainer>
                <HS.Row>
                    <HS.Col>
                        <HS.Title>Программа лояльности</HS.Title>
                        <HS.SubTitle>Получайте бонусы и увеличивайте кешбэк с каждым годом</HS.SubTitle>
                        <HS.Button
                            type={btnTypes.SECONDARY}
                            onClick={headerClickHandler}
                        >
                            Стать участником
                        </HS.Button>
                    </HS.Col>
                    <HS.Col>
                        <HS.Image src='/static/images/loyalty/pl-card.png' alt='Программа лояльности'/>
                    </HS.Col>
                </HS.Row>
            </GridContainer>
        </HS.HeadWrapper>
    );
};

export default Header;
